import React from 'react';
import { S } from './style';
export default function InputText({ align, title, placeholder, value, onInputChange, isError, errMessage, unit, maxLength, inputType, elementRef, }) {
    return (<div ref={elementRef}>
      <S.FieldBox isError={isError}>
        <S.FieldTitle isError={isError}>{title}：</S.FieldTitle>
        <S.InputText align={align} isFull={align === 'full'} placeholder={placeholder} value={value} onChange={onInputChange} maxLength={maxLength} type={inputType}/>

        {unit ? <S.Unit>{unit}</S.Unit> : null}
      </S.FieldBox>
      {isError ? <S.FeedbackErrorText>{errMessage}</S.FeedbackErrorText> : null}
    </div>);
}
